export const hseIncidentDataSources = [
    {
        title: 'High Potential Incident Reports',
        content:'This SharePoint repository contains only final High Potential Incident and Major Incident Investigation reports. Full investigation records and supporting documentation are maintained in Intelex / Enablon. Its primary purpose is to provide Akira, Hitachi Energy’s internal AI, with access to final reports for analysis, learning, and identification of trends, root causes, corrective actions, and lessons learned.',
        sourceSystem: null,
        prompts: [
            'Find HPIs involving crane operations or lifting activities.',
            'Which root causes appear most often in lifting-related incidents?'
        ],
        datasourcelink: ''
    }
]